export default __webpack_public_path__ + "static/media/IMG_20181025_171551_749.afeb32be.jpg";